import React, { useState, useEffect } from "react";
import "./UPI_Withdrawal_Remainder.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Commission_Receive from "../Commission_Receive/Commission_Receive";

function UPI_Withdrawal_Remainder({ show, onHide }) {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = () => {
    // Close first modal
    onHide && onHide();

    // Open second modal
    setModalShow(true);
  };

  // Auto close Commission modal after 3 seconds
  useEffect(() => {
    if (modalShow) {
      const timer = setTimeout(() => {
        setModalShow(false);
        navigate("/home");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalShow, navigate]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        scrollable
        size="sm"
        backdrop="static"
        className="upi_withdrawal_remainder Common_modal"
      >
        <Modal.Body>
          <div className="upi_container">
            <div className="modal_header ">UPI Withdrawal Remainder</div>

            <div className="content_holder">
              <p className="upi_description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </p>

              <div className="upi_image_wrapper">
                <img
                  src="/assets/images/screenshorts/upi_withdrow_reminder.png"
                  alt="UPI Reminder"
                  className="upi_image"
                />
              </div>

              <p className="upi_bottom_text">
                Duis aute irure dolor in reprehenderit.
              </p>
            </div>

            <div className="upi_button_wrapper">
              <Button
                className="btn_register_bg"
                onClick={handleConfirm}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Second Modal */}
      <Commission_Receive
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default UPI_Withdrawal_Remainder;